<div *ngIf="showModal" class="fixed inset-0 z-50 flex items-start top-0 justify-center bg-black/60 pt-10">
    <div
        class="bg-white dark:bg-gray-800 w-full max-w-xl p-6 rounded-lg shadow-lg relative overflow-y-auto max-h-[90vh]">
        <!-- ปุ่มปิด -->
        <button (click)="closeModal()"
            class="absolute top-4 right-4 text-gray-500 hover:text-red-500 text-4xl font-bold">
            &times;
        </button>

        <h2 class="text-xl font-semibold mb-4 dark:text-gray-200">{{ title }}</h2>

        <!-- ค้นหา -->
        <input type="text" [(ngModel)]="searchQuery" [placeholder]="placeholder"
            class="w-full px-3 py-2 mb-4 border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-700 dark:text-gray-200 focus:outline-none focus:ring focus:ring-blue-300" />

        <!-- รายการ -->
        <ul class="max-h-64 overflow-y-auto space-y-2">
            <li *ngFor="let item of filteredData" (click)="selectItem(item)"
                class="p-3 bg-gray-100 dark:bg-gray-700 rounded hover:bg-blue-100 dark:hover:bg-gray-600 cursor-pointer text-gray-800 dark:text-gray-200">
                <div class="font-medium">{{ item.name }}</div>
                <div class="text-sm text-gray-500 dark:text-gray-400" *ngIf="item.address">{{ item.address }}</div>
            </li>

            <li *ngIf="filteredData.length === 0" class="p-3 text-center text-gray-500 dark:text-gray-400">
                ไม่พบข้อมูล
            </li>
        </ul>
    </div>
</div>